import { Person, PersonOff } from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Fab,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";

import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { baseURL } from "../utils/helper";
import ChatbotModal from "./ChatbotModal";
import FAQModal from "./FAQModal";
import FactModal from "./FactModal";
import LoginModal from "./LoginModal";
import MoodScore from "./MoodScore";
import OthersModal from "./OthersModal";
import Testimonials from "./Testimonials";
import { BotAnimation } from "./UI/BotAnimation";
import { HelloAnimation } from "./UI/HelloAnimation";

import Awards from "./Awards";
import JobPostModal from "./JobPostModal";
import CustomCalendar from "./UI/CustomCalendar";

interface Props {}
const useStyles: any = {
  padding: 10,
  textAlign: "center",
  backgroundColor: "rgb(26, 32, 44)",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
function Home(props: Props) {
  const {} = props;
  const faqRef: any = useRef(null);
  const initialCounterValue = {
    tickets: 50,
    queries: 750,
    views: 10,
  };
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const [user, setUser] = useState<any>({});
  const userDetails = JSON.parse(localStorage?.getItem("user") as any);
  const [counterValues, setCounterValues] = useState(initialCounterValue);

  const [openChat, setOpenChat] = useState(false);
  const [othersModal, setOthersModal] = useState(false);
  const [openFAQModal, setOpenFAQModal] = useState(false);
  const [factsModal, setFactsModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [jobPosterModal, setJobPosterModal] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0,
  });
  function showFact() {
    const isFactDisplayed = sessionStorage.getItem("isFactDisplayed");
    if (!isFactDisplayed) {
      setFactsModal(true);
      sessionStorage.setItem("isFactDisplayed", "yes");
    }
  }

  async function connectToSFFromJAVA() {
    fetch(`${baseURL}/fun/connecttosf`, {
      method: "POST",
    })
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  }

  async function getEmployeeDetails() {
    try {
      const employeeDetails = await fetch(
        `${baseURL}/fun/getEmployeeDetailsFromHostName`
      );
      //   const parsedResponse = await employeeDetails.json();
      //   if (parsedResponse?.employee_email_id?.length > 0) {
      //     sessionStorage.setItem("user", JSON.stringify(parsedResponse));
      //     setUser(JSON.stringify(parsedResponse));
      //   }
    } catch (error) {
      console.log("error in getting employee details", error);
    } finally {
      showFact();
    }
  }

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user") as any) || {};
    if (Object.keys(userDetails).length) {
      setUser(userDetails);
    } else {
      getEmployeeDetails();
    }
  }, []);

  function openLoginModal() {
    console.log("called+++++");
    setFactsModal(false);
    setLoginModal(true);
  }
  useEffect(() => {
    if (inView) {
      setCounterValues(initialCounterValue);
    } else {
      setCounterValues({ queries: 0, tickets: 0, views: 0 });
    }
  }, [inView]);
  const steps = [
    {
      selector: ".first-step",
      content: "This is my first Step",
    },
  ];
  return (
    <div id="home">
      <Box>
        <AppBar position="static" style={{ backgroundColor: "#1A202C" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <Avatar
                style={{
                  height: "30px",
                  width: "30px",
                  alignSelf: "flex-end",
                }}
                alt="Remy Sharp"
                src="/RIVA_new.png"
              />
            </IconButton>
            <Button
              color="inherit"
              style={{ textTransform: "none" }}
              onClick={connectToSFFromJAVA}
            >
              Home
            </Button>
            <Button
              className="chatbutton"
              onClick={() => {
                setOpenChat(true);
              }}
              color="inherit"
              style={{ textTransform: "none" }}
            >
              Chat
            </Button>

            <Button
              color="inherit"
              style={{ textTransform: "none" }}
              onClick={() => {
                setOpenFAQModal(true);
              }}
            >
              FAQ
            </Button>

            {!userDetails ? (
              <Button
                color="inherit"
                style={{ textTransform: "none" }}
                sx={{ marginLeft: "auto" }}
                onClick={() => {
                  setLoginModal(true);
                }}
              >
                Login
              </Button>
            ) : (
              <>
                <IconButton
                  sx={{ marginLeft: "auto" }}
                  onClick={handleMenuClick}
                  className="profileclass"
                >
                  <Avatar
                    sx={{
                      backgroundColor: "white",
                      color: "#1A202C",
                    }}
                    src={`${userDetails?.emp_id}.jpg`}
                  >
                    {userDetails?.emp_name[0]?.charAt(0).toUpperCase()}
                  </Avatar>
                </IconButton>
              </>
            )}
          </Toolbar>
        </AppBar>
      </Box>
      <Container id="content" style={{ marginBottom: 20 }}>
        <div>
          <Grid
            container
            style={{ display: "flex", alignContent: "flex-start" }}
          >
            <Grid
              item
              xs={6}
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <BotAnimation />
            </Grid>
            <Grid item xs={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Typography
                  variant="h4"
                  className="scr"
                  style={{
                    textAlign: "left",
                  }}
                >
                  {userDetails?.emp_name
                    ? `Hello ${userDetails?.emp_name?.split(" ")[0]}!`
                    : "Hello there!"}
                  <Divider
                    style={{ width: "50%", backgroundColor: "#1A202C" }}
                    sx={{ borderBottomWidth: 3 }}
                  />
                </Typography>
                <HelloAnimation />
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography
              variant="h6"
              className="scr"
              style={{ textAlign: "center", marginBottom: 5 }}
            >
              Mood Score
            </Typography>

            <Paper
              style={{
                ...useStyles,
                justifyContent: "center",
              }}
            >
              <MoodScore user={user} />
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Typography
              className="scr"
              variant="h6"
              style={{ textAlign: "center", marginBottom: 5 }}
            >
              Pinnacle Performers
            </Typography>
            <Paper
              className="awardclass"
              style={{
                ...useStyles,
                textAlign: "left",
                justifyContent: "center",
              }}
            >
              <Awards />
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Typography
              variant="h6"
              className="scr"
              style={{ textAlign: "center", marginBottom: 5 }}
            >
              Voice of Customer
            </Typography>
            <Paper
              style={{
                ...useStyles,
                textAlign: "left",
                justifyContent: "center",
              }}
            >
              <Testimonials />
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={4}>
          <Grid item xs={4}>
            <Typography
              variant="h6"
              className="scr"
              style={{ textAlign: "center", paddingBottom: 5, paddingTop: 20 }}
            >
              Vacancy Alert
            </Typography>
            <Paper
              style={{
                ...useStyles,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="jobposter.jpg" style={{ height: 372, width: 300 }} />
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Typography
              variant="h6"
              className="scr"
              style={{ textAlign: "center", paddingBottom: 5, paddingTop: 20 }}
            >
              The Events You Can't Miss!
            </Typography>
            <Paper
              style={{
                ...useStyles,
                textAlign: "left",
                justifyContent: "center",
              }}
            >
              <CustomCalendar />
            </Paper>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </Container>
      <div style={{ paddingTop: 50 }}>
        <AppBar
          position="static"
          style={{ backgroundColor: "#1A202C", marginTop: 20 }}
        >
          <Toolbar style={{ display: "flex", justifyContent: "center" }}>
            <Typography style={{ textAlign: "center", fontSize: 12 }}>
              Developed and maintained by IT Next &nbsp;
              <a
                href="mailto:itnext.in@redingtongroup.com"
                style={{ textDecoration: "none", color: "white", fontSize: 12 }}
              >
                itnext.in@redingtongroup.com
              </a>
              <span
                style={{
                  color: "transparent",
                  textShadow: "0 0 0 rgb(255,0,0)",
                  fontSize: "16px",
                }}
              >
                &#9829;
              </span>
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      {openChat && (
        <ChatbotModal
          open={openChat}
          onClosingModal={() => {
            setOpenChat(false);
          }}
          onClickingOthers={() => {
            setOpenChat(false);
            setOthersModal(true);
          }}
        />
      )}
      {othersModal && (
        <OthersModal
          open={othersModal}
          onClosingOthersModal={() => {
            setOthersModal(false);
          }}
        />
      )}
      {factsModal && (
        <FactModal
          open={factsModal}
          onClosingFactModal={() => {
            setFactsModal(false);
          }}
          onClickingLoginModal={() => {
            openLoginModal();
          }}
        />
      )}
      {loginModal && (
        <LoginModal
          open={loginModal}
          onClosingLoginModal={() => {
            setLoginModal(false);
          }}
          onLogin={(parsedResponse) => {
            setUser(parsedResponse);
            setLoginModal(false);
          }}
        />
      )}
      {openFAQModal && (
        <FAQModal
          closeFAQModal={() => {
            setOpenFAQModal(false);
          }}
          openFAQModal={openFAQModal}
        />
      )}
      {jobPosterModal && (
        <JobPostModal
          open={jobPosterModal}
          onClosingJobPostModal={() => {
            setJobPosterModal(false);
          }}
        />
      )}
      <Fab
        style={{
          margin: 0,
          top: "auto",
          right: 30,
          bottom: 20,
          left: "auto",
          position: "fixed",
        }}
        color="secondary"
        aria-label="add"
        onClick={() => {
          setOpenChat(true);
        }}
      >
        <Avatar
          style={{
            height: "80px",
            width: "80px",
            alignSelf: "flex-end",
          }}
          alt="Remy Sharp"
          src="/RIVA_new.png"
        />
      </Fab>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <ListItemIcon>
            <Person fontSize="small" color="success" />
          </ListItemIcon>
          <ListItemText>{userDetails?.emp_name}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            setLoginModal(true);
          }}
        >
          <ListItemIcon>
            <PersonOff fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Not you?</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Home;
